import app from '../app';
import currencies from '../enums/currency';

app.filter('money', ['$sce', '$filter', function ($sce, $filter) {
    return function (amount, symbol) {
        let result = $filter('currency')(amount, '', 0);

        if (symbol) {
            const currency = currencies.find(item => item.key === symbol);
            if (currency) {
                result += '&nbsp;<span>' + currency.name + '</span>';
            }
        }

        return $sce.trustAsHtml(result);
    };
}]);

